import React, { ReactNode } from 'react';

import { Icon } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { TransferEntryType } from '~/repositories';
import { formatString } from '~/util';

const normalizeTransferType = (transferType: string): string => {
  const normalized = String(transferType).toLowerCase().trim();
  if (normalized === 'administrator' || normalized === 'administrative') {
    return 'admin';
  }
  return normalized;
};

export const formatTransferType = (
  transferType?: TransferEntryType,
  { abbreviated }: { abbreviated: boolean } = { abbreviated: true }
) => {
  if (!transferType) {
    return '';
  }

  const normalizedType = normalizeTransferType(String(transferType)) as TransferEntryType;

  switch (normalizedType) {
    case 'ach':
      return 'ACH';
    case 'book':
      return 'Book';
    case 'ach_credit':
      return 'ACH Credit';
    case 'ach_debit':
      return 'ACH Debit';
    case 'check_credit':
    case 'check_debit':
      return 'Check';
    case 'swift':
      return abbreviated ? 'Intl. Wire' : 'International Wire';
    case 'wire-drawdown':
      return 'Wire Drawdown';
    case 'admin':
      return 'Admin';
    case 'crypto':
      return 'Crypto';
    default:
      return formatString(transferType);
  }
};

export const getTransferIcon = (transferType: TransferEntryType | string) => {
  const normalized = normalizeTransferType(String(transferType)).replace(/\s+/g, '_');
  const iconMap: Record<string, ReactNode> = {
    ach_credit: <Icon.Transfer.ACH />,
    ach_debit: <Icon.Transfer.ACH />,
    ach: <Icon.Transfer.ACH />,
    admin: <Icon.Transfer.Admin />,
    book: <Icon.Transfer.Book />,
    check_credit: <Icon.Transfer.Check />,
    check_debit: <Icon.Transfer.Check />,
    check: <Icon.Transfer.Check />,
    wire: <Icon.Transfer.Wire />,
    'wire-drawdown': <Icon.Transfer.Wire />,
    swift: <Icon.Transfer.InternationalWire />,
    intl_wire: <Icon.Transfer.InternationalWire />,
    realtime: <Icon.Transfer.Realtime />,
    crypto: <Icon.Transfer.Wire />,
  };

  return iconMap[normalized] || <Icon.Transfer.Wire />;
};

export const getTransferURL = (transferId: string, transferType: TransferEntryType): string => {
  switch (transferType) {
    case 'ach_credit':
    case 'ach_debit':
      return `${ROUTE.TRANSFERS}/ach/${transferId}`;
    case 'book':
      return `${ROUTE.TRANSFERS}/book/${transferId}`;
    case 'check_credit':
    case 'check_debit':
      return `${ROUTE.TRANSFERS}/check/${transferId}`;
    case 'realtime':
      return `${ROUTE.TRANSFERS}/realtime/${transferId}`;
    case 'swift':
      return `${ROUTE.TRANSFERS}/intl-wire/${transferId}`;
    case 'wire':
      return `${ROUTE.TRANSFERS}/wire/${transferId}`;
    case 'wire-drawdown':
      return `${ROUTE.TRANSFERS}/wire/drawdown/${transferId}`;
    case 'admin':
      return `${ROUTE.TRANSFERS}/admin/${transferId}`;
    case 'crypto':
      return `${ROUTE.TRANSFERS}/crypto/${transferId}`;
    default:
      return `${ROUTE.TRANSFERS}/wire/${transferId}`;
  }
};
